import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import "leaflet-geosearch/dist/geosearch.css";
import VGeosearch from "vue2-leaflet-geosearch";
import HighchartsVue from "highcharts-vue";
import Highcharts from 'highcharts';
import HCMore from 'highcharts/highcharts-more';
import HCStock from "highcharts/modules/stock";
import HCParallel from 'highcharts/modules/parallel-coordinates'


HCMore(Highcharts);
HCParallel(Highcharts)
HCStock(Highcharts);
Vue.use(HighchartsVue);
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-popup', LPopup);
Vue.component('v-geosearch', VGeosearch);

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
